import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { login, logout, validate } from '@/api/Login';
import types from '../types';
import { basicRouters, routes } from '@/router';
import { Message } from 'element-ui';
import { removeToken, setToken } from '@/utils/auth';
import Cookies from 'js-cookie';

const state = {
  userInfo: {},
  roleIds: [],
  routers: []
};

const mutations = {
  [types.SET_USERINFO](state, user) {
    state.userInfo = user;
  },
  [types.CLEAR_LOGININFO](state) {
    state.userInfo = {};
    state.routers = [];
    state.roleIds = [];
  },
  [types.SET_ROUTERS](state, routers) {
    state.routers = [ ...basicRouters, ...routers ];
  },
  [types.SET_ROLEIDS](state, roleIds) {
    state.roleIds = roleIds;
  }
};

const hasPermission = (roles, route) => {
  if (route.meta && route.meta.roles) {
    return !route.meta.roles.length || roles.some(role => route.meta.roles.includes(role));
  }
  return true;
};

const filterRoutes = (routes, roleIds) =>
  (routes.filter(v => {
    if (hasPermission(roleIds, v)) {
      if (v.children && v.children.length > 0) {
        v.children = filterRoutes(v.children, roleIds);
      }
      return v;
    }
    return false;
    // return true;
  }));
// pre.concat(Array.isArray(cur) ? flatten(cur) : [cur])
// 数组扁平化方法，内置flat函数不支持IE
const flatten = ary => ary.reduce((pre, cur) => Array.isArray(cur) ? [...pre, ...cur] : [...pre, cur]);

const actions = {
  logout({ commit }) {
    return logout().then(res => {
      const url = res.data.data;
      commit(types.CLEAR_LOGININFO);
      removeToken();
      return url;
    });
  },
  loginForToken({ commit }, loginData) {
    return login(loginData)
      .then(res => {
        const { data, code, message } = res.data;
        if (code === 200) {
          return res.data;
        } else {
          Message.error(message);
        }
      })
      .catch(error => {
        return Promise.reject(error);
      });
  },
  loginByToken({ dispatch }) {
    return dispatch('getUserInfo').then(user => {
      dispatch('generateRoutes', user);
      // return new Promise(resolve => {
      //   resolve(resolve);
      // });
    }
    );
  },
  getUserInfo({ commit }) {
    return validate()
      .then(res => {
        const { data: user, message } = res.data;
        if (isEmpty(user)) {
          Message.error(message);
          return Promise.reject(message);
        }
        const { roles, status } = user;
        if (!roles) {
          Message.error('当前用户无角色');
          return Promise.reject(message);
        }
        if (status !== 'enable') {
          Message.error('当前用户已禁用');
          return Promise.reject(message);
        }
        setToken();
        commit(types.SET_USERINFO, user);
        return user;
      });
  },
  generateRoutes(context, { resources }) {
    // const codes = user.resources.map(role => role.resourceCodes);
    // const roleIds = Array.from(new Set(flatten(resources)));
    context.commit(types.SET_ROLEIDS, resources);
    return new Promise(resolve => {
      let accessedRouters = filterRoutes(cloneDeep(routes), resources);
      context.commit(types.SET_ROUTERS, accessedRouters);
      resolve(accessedRouters);
    });
  },
  loginForAll({ dispatch }, loginData) {
    return dispatch('loginForToken', loginData).then(({ data }) => {
      setToken();
      Cookies.set('Token', data);
      dispatch('loginByToken');
    });
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/base.js